import React from "react";

export default function IndexSectionFooters7() {
  return (
    <React.Fragment>
      <>
        <section className="relative py-20 overflow-hidden">
          <img
            className="absolute top-0 left-0"
            src="saturn-assets/images/footers/blue-light-left.png"
            alt
          />
          <img
            className="absolute bottom-0 left-1/2 transform -translate-x-1/2"
            src="saturn-assets/images/footers/orange-light-bottom.png"
            alt
          />
          <div className="relative container px-4 mx-auto">
            <div className="max-w-7xl mx-auto">
              <div className="pb-10 mb-10 border-b border-gray-100 items-center">
                <div className="flex flex-wrap -mx-4 items-center">
                  <div className="w-full lg:w-1/2 px-4 mb-4 lg:mb-0">
                    <a className="inline-block" href="#">
                      <img
                        className="h-15"
                        style={{ width: "200px" }}
                        src="saturn-assets/logos/logo.svg"
                        alt
                      />
                    </a>
                  </div>
                  <div className="w-full lg:w-1/2 px-4">
                    <div className="sm:flex -mb-4 items-center lg:justify-end">
                      <span className="inline-block text-gray-900 mb-4 mr-8">
                        まずはお問い合わせしてみませんか？
                      </span>
                      <a
                        className="relative group inline-block w-full sm:w-auto py-3 px-5 mb-4 text-center text-sm font-semibold text-orange-50 bg-orange-900 rounded-md overflow-hidden"
                        href="/contact"
                      >
                        <div className="absolute top-0 right-full w-full h-full bg-gray-900 transform group-hover:translate-x-full group-hover:scale-105 transition duration-500" />
                        <span className="relative">お問い合わせ</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-4 mb-18">
                <div className="w-full sm:w-1/3 lg:w-1/5 px-4 mb-8 sm:mb-0">
                  <h5 className="text-lg font-semibold text-gray-900 mb-4">
                    Services
                  </h5>
                  <ul>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="/"
                      >
                        らくらくQRシステム
                      </a>
                    </li>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="https://mailexpress.hcloud.ltd/"
                        rel="noopener noreferrer"
                      >
                        MailExpress
                      </a>
                    </li>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="https://myfaver.hcloud.ltd/"
                        rel="noopener noreferrer"
                      >
                        myfaver
                      </a>
                    </li>
                    <li>
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="https://hstorage.io/"
                        rel="noopener noreferrer"
                      >
                        HStorage
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full sm:w-1/3 lg:w-1/5 px-4 mb-8 sm:mb-0">
                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    About
                  </h5>
                  <ul>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="https://hcloud.ltd/"
                        rel="noopener noreferrer"
                      >
                        合同会社 HCloud
                      </a>
                    </li>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="/legal"
                      >
                        特定商取引法に基づく表記
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full sm:w-1/3 lg:w-1/5 px-4">
                  <h5 className="text-lg font-semibold text-gray-900 mb-4">
                    Help
                  </h5>
                  <ul>
                    <li className="mb-4">
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="/#faq"
                      >
                        よくある質問
                      </a>
                    </li>
                    <li>
                      <a
                        className="inline-block text-gray-500 hover:text-gray-600"
                        href="/contact"
                      >
                        お問い合わせ
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="sm:flex items-center justify-between">
                <div className="sm:flex mb-6 sm:mb-0 items-center">
                  <a
                    className="inline-block mr-6 sm:mr-12 text-gray-900 hover:text-gray-600"
                    href="/terms"
                  >
                    利用規約
                  </a>
                  <a
                    className="inline-block text-gray-900 hover:text-gray-600"
                    href="/privacy"
                  >
                    プライバシーポリシー
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
